module.exports = __webpack_public_path__ + "media/images/drivers/small/DEFAULT-2f3194fd2e28694dad355cfe9ca79ae0.png";